export const clean = (obj) => Object.fromEntries(
    Object.entries(obj).filter(([_, v]) =>
        v !== undefined && v !== null && v !== '' && !(typeof v === 'number' && isNaN(v)))
);

export const parcelFields = (p = {}) => {
    const num = (v) => (v === '' || v == null ? undefined : Number(v));
    return clean({
        weight_unit: num(p.weight_unit), weight: num(p.weight),
        size_unit: num(p.size_unit), length: num(p.length), height: num(p.height),
    });
};

export const buildParcelBody = (form) => {
    const { sender, recipient } = form;
    const validStops = (form.stops || []).filter(s => s.latitude && s.longitude);
    const waypoints = validStops.map((s, i) => ({
        address: s.address, latitude: s.latitude, longitude: s.longitude, stop_id: i + 1,
    }));
    const stop_parcel_details = validStops.map((s, i) => clean({
        stop_id: i + 1,
        sender_name: sender.name, sender_mobile: sender.phone, sender_flat_house_no: sender.flat,
        recipient_name: s.contact?.name, recipient_mobile: s.contact?.phone,
        recipient_flat_house_no: s.contact?.flat,
        sender_instructions: sender.instructions,
        ...parcelFields(s.parcel),
    }));
    return {
        ...parcelFields(recipient.parcel),
        waypoints,
        ...(stop_parcel_details.length ? { stop_parcel_details } : {}),
    };
};